// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// core components
import GridContainer from "../Grid/GridContainer.js";
import GridItem from "../Grid/GridItem.js";
import Image from "next/image.js";
import Link from "next/link.js";

import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";
import {buildSlug} from "../../util/url";

const useStyles = makeStyles()(styles);

export default function ForumsCategories(props) {
  const { classes, cx } = useStyles();
  const categories = props.data.subCategories;

  return (
    <GridContainer className={classes.forumCategoryContainer}>
      {categories.map((category, index) => {
        return (
          <GridItem
            className={classes.forumCategory}
            key={index}
            xs={6}
            sm={6}
            md={3}
            lg={2.4}
          >
            <Link
              className={classes.forumCategoryName}
              href={`/community/${buildSlug(category.name)}-${category.subCatId}`}
            >
              <div className={classes.forumCategoryImageContainer}>
              <Image
                className={classes.forumCategoryImage}
                src={category.image}
                alt={category.name}
                width={180}
                height={180}
              />
              </div>
              <h2 className={classes.forumCategoryName}>{category.name}</h2>
            </Link>
          </GridItem>
        );
      })}
    </GridContainer>
  );
}
